import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { analyticsService } from '../api/analytics.service';
import { ANALYTICS_KEYS } from './queryKeys';
import type { AllTasksParams } from '../types';

export function useAllTasks(params?: AllTasksParams) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: ANALYTICS_KEYS.allTasks(activeOrganizationId ?? '', params),
    queryFn: ({ signal }) => analyticsService.getAllTasks(params, signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId,
  });
}
